import React, { useState, useRef } from 'react';

import { Link } from 'gatsby';
import SimpleBar from 'simplebar-react';

import {
  useIntl,
  FormattedMessage,
} from '../../../../plugins/publicis-gatsby-plugin-i18n';
import {
  AccessibiliteIcon,
  ArrowIconGoRight,
  CloseIcon,
  HomeIcon,
} from '../../../Atoms/Icons/Icons';
import useMedias from '../../../hooks/useMedias';
import Languages from '../../Languages/Languages';

import './BurgerMenu.scss';
import 'simplebar/dist/simplebar.min.css';

let classNames = require('classnames');

const BurgerMenu = ({
  latestPublication,
  latestCommunication,
  menus,
  footerLegale,
  allDocuments,
}) => {
  const intl = useIntl();
  const { getDocument } = useMedias();

  const burgerRef = useRef(null);
  const [showMenu, setShowMenu] = useState(false);
  const [navInvisible, setNavInvisible] = useState(true);

  const onOpenBurgerMenu = (e) => {
    e.preventDefault();
    setShowMenu(true);
    setNavInvisible(false);
    document.addEventListener('click', handleOutsideClick, false);
  };

  const onCloseBurgerMenu = (e) => {
    e.preventDefault();
    setShowMenu(false);

    setTimeout(() => {
      setNavInvisible(true);
    }, 300);
    document.removeEventListener('click', handleOutsideClick, false);
  };

  const handleOutsideClick = (e) => {
    if (e.target.matches('.link_access_keys.link-menu') && showMenu) {
      return;
    }
    if (burgerRef && burgerRef?.current?.contains(e.target)) {
      return;
    }
    if (e.target.closest('.popin_accessibilite')) {
      return;
    }
    setShowMenu(false);
    setTimeout(() => {
      setNavInvisible(true);
    }, 300);
  };

  const onShowAccessibilite = (e) => {
    e.preventDefault();
    document.body.classList.add('show_accessibility_popin');
  };

  const onKeyDownFooterLink = (e, isLast) => {
    if (e.keyCode === 9 && isLast) {
      e.preventDefault();
      document.querySelector('.burger_menu_sidebar .link_home').focus();
    }
  };
  const latestPublication_pdf = getDocument(allDocuments, latestPublication.relationships?.field_media_pdf?.drupal_internal__mid)?.uri?.url;
  return (
    <div className="burgerMenu" ref={burgerRef}>
      <a
        className="burger_btn"
        href="#"
        onClick={onOpenBurgerMenu}
        aria-label={intl.formatMessage({ id: 'ariaLabel.open_menu' })}
        aria-expanded={showMenu ? 'true' : 'false'}
      >
        <div className="burger_icon">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <span className="menu_text">Menu</span>
      </a>
      <nav
        className={classNames(
          'burger_menu_sidebar',
          { show: showMenu },
          { invisible: navInvisible }
        )}
        aria-hidden={showMenu ? 'false' : 'true'}
        tabIndex={showMenu ? 1 : -1}
      >
        <SimpleBar style={{ maxHeight: '100vh' }}>
          <ul className="topnav">
            <li>
              <Link
                to={'/'}
                className="link_home"
                aria-label={intl.formatMessage({
                  id: 'ariaLabel.go_to_homepage',
                })}
              >
                <HomeIcon fill="#ffffff" />
                <FormattedMessage id="common.goto.home">
                  {(x) => <span>{x}</span>}
                </FormattedMessage>
              </Link>
            </li>
            <li>
              <a
                href="#"
                className="close_burger_menu"
                onClick={onCloseBurgerMenu}
                aria-label={intl.formatMessage({ id: 'ariaLabel.close_menu' })}
              >
                <CloseIcon fill="#ffffff" />
                <FormattedMessage id="common.close">
                  {(x) => <span>{x}</span>}
                </FormattedMessage>
              </a>
            </li>
          </ul>
          <div className="access_lang">
            <a
              href="#"
              className="accessibilite"
              onClick={(e) => onShowAccessibilite(e)}
            >
              <AccessibiliteIcon />
              <FormattedMessage id="accessibility.title" />
            </a>
            <Languages />
          </div>
          <ul className="link_documents">
            <li>
              <Link
                to={
                  '/' +
                  latestCommunication.path.langcode +
                  latestCommunication.path.alias
                }
              >
                {latestCommunication.title} <ArrowIconGoRight fill="#ffffff" />
              </Link>
            </li>
            {
              latestPublication_pdf &&
              <li>
                <a
                  // href={
                  //   getDocument(allDocuments, latestPublication.relationships?.field_media_pdf?.drupal_internal__mid)?.uri?.url
                  // }
                  href={`${process.env.GATSBY_METADATA_SITE_URL}${intl.locale}/pdf/?file=https:${latestPublication_pdf}&title=${latestPublication.title}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {latestPublication.title}
                  <ArrowIconGoRight fill="#ffffff" />
                </a>
              </li>
            }

          </ul>
          <ul className="main_nav">
            {menus.map((menu, i) => (
              <li
                key={i}
                className={menu.title === 'logo_elem' ? 'logo_elem' : null}
              >
                {menu.submenus && menu.submenus.length > 0 && menu.expanded ? (
                  <>
                    <span className="menu_title">{menu.title}</span>
                    <ul className="sub_nav">
                      {menu.submenus.map((submenu, j) => (
                        <li key={j}>
                          <Link to={submenu.href}>{submenu.title}</Link>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <Link to={menu.href}>{menu.title}</Link>
                )}
              </li>
            ))}
          </ul>
          <ul className="burger_footer_menu">
            {footerLegale.map((item, index) => (
              <li key={item.id}>
                <Link
                  to={item.link}
                  onKeyDown={(e) =>
                    onKeyDownFooterLink(e, index == footerLegale.length - 1)
                  }
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </SimpleBar>
      </nav>
    </div>
  );
};
export default BurgerMenu;
